export const FIRM_SELECTOR_LOADING_LABEL = 'Loading your firms.';
